import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import Fishbone from '../Fishbone/Fishbone'
import Chart from '../Chart';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { useState } from 'react';
import { GapHelpTexts } from '../../../../../../common/HelpPageText';
import { TeachBubble } from '../../../../../Templates/TeachBubble';
import { __BoardCalendarFilter } from '../../../../../../common/Dictionaries';
import { useContext } from 'react';
import MainAppContext from '../../../../../../MainAppContext';
import { ActionButton } from '@fluentui/react';
import GapAppContext from '../../../../../../GapAppContext';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import SidePanelGapDataserieComments from './SidePanelGapDataserieComments';
//import MyChart from '../Chart/Chart3';

function FishboneCard(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextGap = useContext(GapAppContext);
   
    const {
        inputParam_GapAnalyzeId = null,
        inputParam_ElementId = null,
        inputParam_GapId = null,
        inputParam_GapRevision = null,
        inputParam_DataserieFullData = null,
        inputParam_GapRevisionDataserieList = null,
        inputParam_GapElementList = null,
        inputParam_Index = null,
        inputParam_Item = null,
        inputParam_SetFireGetLastActions = null,
    } = props;

    const _priv_canAddDataserieMessages = true


    const [isDataserieCommentsPanelOpen, setIsDataserieCommentsPanelOpen] = useState(false)
    const [dataserieValueChartSelected, setDataserieValueChartSelected] = useState(inputParam_Item.l_dataserie_vals.filter(x => x.gapResult === true)[0])
    const [causeList, setCauseList] = useState({fireSearch: true, data: null});

    const setterOnChildChartColumnClick = (value) => {
        setDataserieValueChartSelected(value)
        setCauseList({fireSearch: true, data: null})
    }

    const onRefreshDataserie = () => {
        /*contextGap.gapRevisionDataserieList.set(prevState => ({
            ...prevState,
            revisionDataserieFullList:null,
        }));*/

        window.location.href = window.location.href;
    }

    const onOpenCommentsPanel = () => {
        setIsDataserieCommentsPanelOpen(true);
    }

    const calculateStatusGap = () => {
        let statusText = "";
        if (!isNullUndefinedOrEmpty(dataserieValueChartSelected)) {
            statusText = t("data-lang-skgap-gap-status" + dataserieValueChartSelected.statusGap);
        } 
        else {
            if (inputParam_Item.lastRefGapDataserieValueId !== null) {

                const aux_lastDataserieValue = inputParam_Item.l_dataserie_vals.find(x => x.id === inputParam_Item.lastRefGapDataserieValueId);

                if (aux_lastDataserieValue !== null && aux_lastDataserieValue !== undefined) {
                    statusText = t("data-lang-skgap-gap-status" + aux_lastDataserieValue.statusGap);
                }
                else {
                    statusText = t("data-lang-skgap-gap-status-1");
                }
            }
            else {
                statusText = '';
            }
        }
        
        return statusText;
    }

    return (
            <Card data-dataserie-id={inputParam_Item.dataserieId} className='mb-1'  style={{ borderLeftWidth: '20px', borderLeftStyle: 'solid', borderLeftColor: `${!isNullUndefined(inputParam_GapElementList) && inputParam_GapElementList.length > 0 ? inputParam_GapElementList.find(element => element.id === inputParam_Item.gapAnalyzeElementId).htmlColor : ''}`}}>
                <Card.Body className='py-1'>
                    <Row>
                        <Col xl={4} className='px-0 pe-1'>
                            <Card className='h-100'>
                                {
                                    inputParam_Index === 0 &&
                                    <Card.Header id='crdSelectGap' className="card-header-compact">
                                        <Row className='d-flex'>
                                            <Col>
                                                <h5><b>{t('data-lang-lbl-dataserie')}</b></h5>
                                            </Col>
                                            <Col className='col-auto px-0'>
                                                <ActionButton className='pb-2' iconProps={{ iconName: "Refresh"}} onClick={() => onRefreshDataserie()} allowDisabledFocus >
                                                    { t('data-lang-btn-refresh')}
                                                </ActionButton>
                                            </Col>
                                            <Col className='col-auto d-flex pt-1'>
                                                <TeachBubble
                                                    inputParam_ButtonId={ "btnHelpProcessPosibleGaps_Revision" }
                                                    inputParam_Text={
                                                        <Row>
                                                            <Col className='mb-2' xl={12}><b>{t(GapHelpTexts.gapDataserieChartColorBlueName)}</b>: {t(GapHelpTexts.gapDataserieChartColorBlue)}</Col>
                                                            <Col className='mb-2' xl={12}><b>{t(GapHelpTexts.gapDataserieChartColorGreenName)}</b>: {t(GapHelpTexts.gapDataserieChartColorGreen)}</Col>
                                                            <Col className='mb-2' xl={12}><b>{t(GapHelpTexts.gapDataserieChartColorRedName)}</b>: {t(GapHelpTexts.gapDataserieChartColorRed)}</Col>
                                                            <Col className='mb-2' xl={12}><b>{t(GapHelpTexts.gapDataserieChartColorPurpleName)}</b>: {t(GapHelpTexts.gapDataserieChartColorPurple)}</Col>
                                                        </Row>
                                                    }
                                                    inputParam_IsHTML={true}
                                                    inputParam_Title={ t('data-lang-helptext-title') }
                                                />
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                }
                                <Card.Body className='h-100'>
                                    {
                                        inputParam_Item.l_dataserie_vals.length > 0 &&
                                        <Row>
                                            <Col>
                                                <Chart
                                                    inputParam_ComponentData={inputParam_Item.l_dataserie_vals}
                                                    inputParam_SetterDataserieValueChartSelected={setterOnChildChartColumnClick}
                                                    inputParam_Height={300}
                                                    inputParam_CircleColor={inputParam_Item.colorGap}
                                                    inputParam_Title={
                                                                        <div className='d-flex align-items-end'>
                                                                        {
                                                                            <h6 className='mb-2'>
                                                                                <b>
                                                                                    {
                                                                                        `${inputParam_GapRevisionDataserieList.find(x => x.gapAnalyzeElementId === inputParam_Item.gapAnalyzeElementId && inputParam_Item.dataserieId === x.dataserieId) !== undefined ? inputParam_GapRevisionDataserieList.find(x => x.gapAnalyzeElementId === inputParam_Item.gapAnalyzeElementId && inputParam_Item.dataserieId === x.dataserieId).name : ""}`
                                                                                    }
                                                                                </b>
                                                                            </h6>
                                                                        }
                                                                        {
                                                                            <div className='mb-2' style={{fontSize: "12px"}}>
                                                                                {
                                                                                    `(${inputParam_GapRevisionDataserieList.find(x => x.gapAnalyzeElementId === inputParam_Item.gapAnalyzeElementId && inputParam_Item.dataserieId === x.dataserieId) !== undefined ? inputParam_GapRevisionDataserieList.find(x => x.gapAnalyzeElementId === inputParam_Item.gapAnalyzeElementId && inputParam_Item.dataserieId === x.dataserieId).um : "sdd"})`
                                                                                }
                                                                            </div>
                                                                        }
                                                                        </div>
                                                                    }
                                                    inputParam_SubTitle={
                                                                            <>
                                                                                <div style={{fontSize: "14px"}}>
                                                                                <b>{`${ t('data-lang-lbl-selectedperiodtime')}`}</b>{`: ${ t(__BoardCalendarFilter.find(x => x.key === contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId).text)}`}
                                                                                </div>
                                                                                <div style={{fontSize: "14px"}}>
                                                                                <b>{`${ t('data-lang-lbl-measurementperiod') }`}</b>{`: ${ inputParam_GapRevisionDataserieList.find(x => x.gapAnalyzeElementId === inputParam_Item.gapAnalyzeElementId !== undefined) ? t(inputParam_GapRevisionDataserieList.find(x => x.gapAnalyzeElementId === inputParam_Item.gapAnalyzeElementId).meassurePeriod) : "" }`}
                                                                                </div>
                                                                            </>
                                                                        }
                                                />
                                                
                                                {
                                                    (dataserieValueChartSelected || inputParam_Item.lastRefGapDataserieValueId) &&
                                                    <Row data-id={inputParam_Item.id} className='pt-2 ps-5'>
                                                        <Col xl={12} className="border-bottom">
                                                            <Row>
                                                                <Col><b>{`${ t('data-lang-lbl-period')}`}</b>{ `: ${ !isNullUndefinedOrEmpty(dataserieValueChartSelected) ? (!isNullUndefinedOrEmpty(dataserieValueChartSelected.serieTimeStr) ? dataserieValueChartSelected.serieTimeStr : dataserieValueChartSelected.x) : (inputParam_Item.lastRefGapDataserieValueId !== null ? inputParam_Item.l_dataserie_vals.find(x => x.id === inputParam_Item.lastRefGapDataserieValueId).serieTime : '') }`}</Col>
                                                                <Col className='col-auto me-auto'><ActionButton iconProps={{iconName: 'FileComment'}} text={t('data-lang-btn-comments')} onClick={onOpenCommentsPanel} /></Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xl={6} style={{fontSize: "14px"}}>
                                                            <Row>
                                                                <Col><b>{`${ t('data-lang-lbl-real')}`}</b>{ `: ${ !isNullUndefinedOrEmpty(dataserieValueChartSelected) ? (!isNullUndefinedOrEmpty(dataserieValueChartSelected.displayValue) ? dataserieValueChartSelected.displayValue : dataserieValueChartSelected.y) : (inputParam_Item.lastRefGapDataserieValueId !== null ? inputParam_Item.l_dataserie_vals.find(x => x.id === inputParam_Item.lastRefGapDataserieValueId).displayValue : '') }`}</Col>
                                                            </Row>
                                                            <Row>
                                                                <Col><b>{`${ t('data-lang-lbl-goal')}`}</b>{ `: ${ !isNullUndefinedOrEmpty(dataserieValueChartSelected) ? dataserieValueChartSelected.valueGoal : (inputParam_Item.lastRefGapDataserieValueId !== null ? inputParam_Item.l_dataserie_vals.find(x => x.id === inputParam_Item.lastRefGapDataserieValueId).valueGoal : '') }`}</Col>
                                                            </Row>
                                                            <Row>
                                                                <Col><b>{`${ t('data-lang-lbl-goalpercent')} `}</b>{ `: ${ !isNullUndefinedOrEmpty(dataserieValueChartSelected) ? dataserieValueChartSelected.valueGoalPercent : (inputParam_Item.lastRefGapDataserieValueId !== null ? inputParam_Item.l_dataserie_vals.find(x => x.id === inputParam_Item.lastRefGapDataserieValueId).valueGoalPercent : '') }%`}</Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xl={6} style={{fontSize: "14px"}}>
                                                            <Row>
                                                                {
                                                                    !isNullUndefinedOrEmpty(dataserieValueChartSelected) &&
                                                                    <Col
                                                                        data-status-gap={dataserieValueChartSelected.statusGap}
                                                                        data-dataserie-id={dataserieValueChartSelected.id}
                                                                    >
                                                                        <b>{`${ t('data-lang-lbl-gapstatus')}`}</b>{ `: ${ calculateStatusGap() }`}
                                                                    </Col>
                                                                }
                                                                {
                                                                    isNullUndefinedOrEmpty(dataserieValueChartSelected) &&
                                                                    <Col>
                                                                        <b>{`${ t('data-lang-lbl-gapstatus')}`}</b>{ `: ${ calculateStatusGap() }`}
                                                                    </Col>
                                                                }
                                                            </Row>
                                                            <Row>
                                                                <Col><b>{`${ t('data-lang-lbl-causes')}`}</b>{ `: ${ !isNullUndefinedOrEmpty(dataserieValueChartSelected) ? dataserieValueChartSelected.totalCauses : (inputParam_Item.lastRefGapDataserieValueId !== null ? inputParam_Item.l_dataserie_vals.find(x => x.id === inputParam_Item.lastRefGapDataserieValueId).totalCauses : '') }`}</Col>
                                                            </Row>
                                                            <Row>
                                                                <Col><b>{`${ t('data-lang-lbl-actions')}`}</b>{ `: ${ !isNullUndefinedOrEmpty(dataserieValueChartSelected) ? dataserieValueChartSelected.totalActions : (inputParam_Item.lastRefGapDataserieValueId !== null ? inputParam_Item.l_dataserie_vals.find(x => x.id === inputParam_Item.lastRefGapDataserieValueId).totalActions : '') }`}</Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                }
                                            </Col>
                                        </Row>
                                    }
                                    <NoDataLayer display={inputParam_Item.l_dataserie_vals.length === 0} text={t('data-lang-lbl-nopreviousdata')} />
                                    {
                                        isDataserieCommentsPanelOpen &&
                                        <SidePanelGapDataserieComments
                                            inputParam_GapId={inputParam_GapId}
                                            inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                            inputParam_EditMode={_priv_canAddDataserieMessages}
                                            inputParam_DataserieName={inputParam_Item.name}
                                            inputParam_DataserieValue={dataserieValueChartSelected}
                                            inputParam_DataserieValueId={dataserieValueChartSelected.id}
                                            inputParam_IsPanelOpen= {isDataserieCommentsPanelOpen}
                                            inputParam_SetterIsPanelOpen={setIsDataserieCommentsPanelOpen}
                                        />
                                    }
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xl={8}>
                            {
                                inputParam_DataserieFullData.gapFishboneList.length > 0 &&
                                <Fishbone
                                    inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                    inputParam_ElementId={inputParam_ElementId}
                                    inputParam_RevisionDataserie={inputParam_Item}
                                    inputParam_GapRevision={inputParam_GapRevision}
                                    inputParam_FishboneIndex={inputParam_Index}
                                    inputParam_DataserieValueChartSelected={dataserieValueChartSelected}
                                    inputParam_CauseList={causeList}
                                    inputParam_SetterCauseList={setCauseList}
                                    inputParam_HasFishbone={inputParam_DataserieFullData.gapFishboneList !== null ? (inputParam_DataserieFullData.gapFishboneList.find(x => x !== null ? x.gapAnalyzeDataserieId === inputParam_Item.id && x.objNew !== null : false) !== undefined ? true : false) : false}
                                    inputParam_SetFireGetLastActions={inputParam_SetFireGetLastActions}
                                />
                            }
                            <NoDataLayer display={inputParam_Item.fishBone === null} />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
    );
}

FishboneCard.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevision: PropTypes.object,
    inputParam_GapRevisionDataserieList: PropTypes.array.isRequired,
    inputParam_GapElementList: PropTypes.array.isRequired,
    inputParam_Index: PropTypes.number.isRequired,
};

export default FishboneCard;